import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import DoKoHome from "../views/DoKoHome.vue";
import { ROUTE_NAMES } from "./routenames";

import store, { api } from "../store";

// route level code-splitting
// this generates a separate chunk (about.[hash].js) for this route
// which is lazy-loaded when the route is visited.
const DoKoDesk = () =>
  import(/* webpackChunkName: "doko-game" */ "../views/DoKoDesk.vue");
const DoKoLobby = () =>
  import(/* webpackChunkName: "doko-game" */ "../views/DoKoLobby.vue");
const DoKoSignin = () =>
  import(
    /* webpackChunkName: "doko-game" */ "../components/dialogs/DoKoSignin.vue"
  );

const DoKoSignup = () =>
  import(
    /* webpackChunkName: "doko-game" */ "../components/dialogs/DoKoSignup.vue"
  );

const DoKoCreateDesk = () =>
  import(
    /* webpackChunkName: "doko-game" */ "../components/dialogs/DoKoCreateDesk.vue"
  );

const DoKoDialogBlanc = () =>
  import(
    /* webpackChunkName: "doko-game" */ "../components/dialogs/DoKoDialogTisch.vue"
  );

const DoKoDialogWaitingForInvites = () =>
  import(
    /* webpackChunkName: "doko-game" */ "../components/dialogs/DoKoDialogWaitingForInvites.vue"
  );

const DoKoDialogRegeln = () =>
  import(
    /* webpackChunkName: "doko-game" */ "../components/dialogs/DoKoDialogRegeln.vue"
  );

const DoKoDialogPlayers = () =>
  import(
    /* webpackChunkName: "doko-game" */ "../components/dialogs/DoKoDialogPlayers.vue"
  );

const DoKoDialogProfileEdit = () =>
  import(
    /* webpackChunkName: "doko-game" */ "../components/dialogs/DoKoProfileEdit.vue"
  );

const DoKoDialogStatistics = () =>
  import(
    /* webpackChunkName: "doko-game" */ "../components/dialogs/DoKoDialogStatistics.vue"
  );
const DoKoDialogTablestats = () =>
  import(
    /* webpackChunkName: "doko-game" */ "../components/dialogs/DoKoDialogTablestats.vue"
  );
const DoKoDialogSpielergebnis = () =>
  import(
    /* webpackChunkName: "doko-game" */ "../components/dialogs/DoKoDialogSpielergebnis.vue"
  );

const DoKoDialogImages = () =>
  import(
    /* webpackChunkName: "doko-game" */ "../components/dialogs/DoKoDialogImages.vue"
  );

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: "/",
    name: ROUTE_NAMES.HOME,
    component: DoKoHome,
  },
  {
    path: "/signin",
    name: ROUTE_NAMES.LOGIN,
    component: DoKoSignin,
  },
  {
    path: "/signup",
    name: ROUTE_NAMES.SIGNUP,
    component: DoKoSignup,
  },
  {
    path: "/lobby",
    name: ROUTE_NAMES.LOBBY,
    component: DoKoLobby,
    meta: { requiresLogin: true },
  },
  {
    path: "/start-game",
    name: ROUTE_NAMES.START_GAME,
    component: DoKoDialogWaitingForInvites,
    meta: { requiresLogin: true },
  },
  {
    path: "/create-desk",
    name: ROUTE_NAMES.CREATE_DESK,
    component: DoKoCreateDesk,
    meta: { requiresLogin: true },
  },
  {
    path: "/desk/:deskId",
    props: true,
    name: ROUTE_NAMES.DESK,
    component: DoKoDesk,
    meta: { requiresLogin: true },
    children: [
      {
        path: "tablestats",
        name: ROUTE_NAMES.TABLESTATS,
        component: DoKoDialogTablestats,
        meta: { requiresLogin: true },
      },
      {
        path: "game/:gameNo?",
        props: true,
        name: ROUTE_NAMES.GAMERESULT,
        component: DoKoDialogSpielergebnis,
        meta: { requiresLogin: true },
      },
    ],
  },
  {
    path: "/rules",
    name: ROUTE_NAMES.RULES,
    component: DoKoDialogRegeln,
    meta: { requiresLogin: true },
  },

  {
    path: "/players",
    name: ROUTE_NAMES.PLAYERS,
    component: DoKoDialogPlayers,
    meta: {
      requiresLogin: true,
    },
  },

  {
    path: "/profile-edit",
    name: ROUTE_NAMES.PROFILE_EDIT,
    component: DoKoDialogProfileEdit,
    meta: { requiresLogin: true },
  },

  {
    path: "/statistics",
    name: ROUTE_NAMES.STATISTICS,
    component: DoKoDialogStatistics,
    meta: { requiresLogin: true },
  },

  {
    path: "/wait-for-invite",

    name: ROUTE_NAMES.WAIT_FOR_INVITES,
    component: DoKoDialogWaitingForInvites,
    meta: { requiresLogin: true },
  },
  {
    path: "/demo",
    props: true,
    name: "demo",
    component: DoKoDialogBlanc,
    meta: { requiresLogin: true },
  },
  {
    path: "/image-overview/:imageListId?",
    props: true,
    name: ROUTE_NAMES.IMAGES,
    component: DoKoDialogImages,
    meta: { requiresLogin: false },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, _from, next) => {
  if (
    to.matched.some((record) => record.meta.requiresLogin) &&
    store.getters[api.getters.isUserAuthenticated] !== true
  ) {
    // You can use store variable here to access globalError or commit mutation
    next();
    // next({
    //   name: ROUTE_NAMES.LOGIN,
    //   query: { redirect: to.fullPath }
    // });
  } else {
    next();
  }
});

export default router;
